import React from 'react';
import ReactDOM from 'react-dom';
import keycloak from './lib/keycloak'
import { rollbar } from './data/Logging'
import App from './App.jsx'
import {I18nextProvider} from 'react-i18next';
import i18n from './utils/i18n';
import * as serviceWorker from './serviceWorker';
import './scss/global.scss';
import 'react-smartbanner/dist/main.css'

rollbar()

keycloak()

i18n.init({
  react: {
    useSuspense: false
  }
});

function runApp() {
  ReactDOM.render(
    <I18nextProvider i18n={ i18n }>
      <App/>
    </I18nextProvider>,
    document.getElementById('content')
  );
}

if (!window.Intl) {
  import('./intl-polyfill').then(({ Intl }) => {
    window.Intl = Intl
    runApp()
  })
  .catch((e) => {
    console.error(e)
  })
} else {
  runApp();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();